import React from "react";
import ModalWrapper from './ModalWrapper';

const ImpactoAmbiental = props => {
  return(
    <ModalWrapper
      {...props}
    >
      <div>
        <h4>Produtos Mais Sustentáveis</h4>
        <p>Queremos, cada vez mais, oferecer para nossos(as) clientes produtos saudáveis e sustentáveis que respeitem o meio ambiente, as pessoas e o bem estar animal. Conheça alguns que você encontra em nossas lojas:</p>
        <ul className="list-unstyled">
          <li>
            <a target="_blank" href="https://content.paodeacucar.com/sustentabilidade/o-que-sao-alimentos-organicos?utm_source=SiteSustentabilidade&utm_medium=Hub&utm_term=ConceitoSust">
              Alimentos orgânicos
            </a>
          </li>
          <li>
            <a target="_blank" href="https://content.paodeacucar.com/prazer-de-comer-e-beber/rubia-gallega?utm_source=SiteSustentabilidade&utm_medium=Hub&utm_term=ConceitoSust">
              Rubia Gallega
            </a>
          </li>
          <li>
            Produtos de comércio justo (Caras do Brasil e Amigos do Bem)
          </li>
          <li>
            <a target="_blank" href="https://www.gpabr.com/pt/sustentabilidade/transformacao-da-cadeia-de-valor?utm_source=SiteSustentabilidade&utm_medium=Hub&utm_term=ConceitoSust">
              Produtos que consideram o Bem Estar Animal
            </a>
          </li>
        </ul>
      </div>
    </ModalWrapper>
  );
};

export default ImpactoAmbiental;



// WEBPACK FOOTER //
// ./src/components/ProdutosMaisSustentaveis.js